import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { TextMaskModule } from 'angular2-text-mask';
import { NgBrazil } from 'ng-brazil';
import { NgDragDropModule } from 'ng-drag-drop';
import { FileUploadModule } from 'ng2-file-upload';
import { ClipboardModule } from 'ngx-clipboard';
import { ColorPickerModule } from 'ngx-color-picker';
import { LightboxModule } from 'ngx-lightbox';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSummernoteModule } from 'ngx-summernote';
import { BiIntegradorOrcamentoComponent } from 'src/app/crm/bi/bi-integrador-orcamento/bi-integrador-orcamento.component';
import { BiIntegradorPedidoComponent } from 'src/app/crm/bi/bi-integrador-pedido/bi-integrador-pedido.component';
import { BiIntegradorComponent } from 'src/app/crm/bi/bi-integrador/bi-integrador.component';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { MaterialModule } from 'src/app/material.module';
import { MdModule } from 'src/app/md/md.module';
import { PipesModule } from 'src/app/pipes/pipes.module';

@NgModule({
  declarations: [BiIntegradorComponent, BiIntegradorOrcamentoComponent, BiIntegradorPedidoComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MdModule,
    MaterialModule,
    TextMaskModule,
    NgBrazil,
    NgSelectModule,
    NgxSpinnerModule,
    FileUploadModule,
    PerfectScrollbarModule,
    NgxChartsModule,
    NgDragDropModule.forRoot(),
    PipesModule,
    ClipboardModule,
    DirectivesModule,
    ColorPickerModule,
    LightboxModule,
    NgxSummernoteModule,
  ],
  exports: [BiIntegradorComponent, BiIntegradorOrcamentoComponent, BiIntegradorPedidoComponent],
})
export class BIModule {}
